import Vue from 'vue'
import 'babel-polyfill'
import App from './App'
import router from './router'
import './http/index.js'
import store from './vuex'
import { Carousel, CarouselItem } from 'element-ui'

Vue.component(Carousel.name, Carousel)
Vue.component(CarouselItem.name, CarouselItem)

initVue()

function initVue () {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
  })
}



// WEBPACK FOOTER //
// ./src/main.js